import axios from 'axios';
import getSharedLinkCode from '@/helpers/dashboard/getSharedLinkCode';

export const actions = {
    async store(vuexContext, payload) {
        // A shared-link viewer has no account session: the 401 would send them to the login page.
        if (getSharedLinkCode()) return;

        return axios.$post('/v1/account_events', payload);
    }
};
